import _ from 'lodash';
import { ReactElement, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux';
import { ClientReducerState } from 'client/reducers';
import { useDidMount } from 'common/components/useDidMount';
import { getStoryLastCardId, isPreview } from 'client/utils';
import { isScreenshot } from 'client/actions/api-events';
import { parseURL, searchObjectToString } from 'common/utils';

type Props = ConnectedProps<typeof connector> & RouteComponentProps & { children: ReactElement };

const RedirectController = (props: Props) => {
	const [status, setStatus] = useState(false);

	useDidMount(() => {
		if (!isPreview && !isScreenshot() && window.localStorage) {
			const { cardId } = parseURL(window.location.search).searchObject;
			const checkpoint = props.oncePerUser ? props.checkpoint : getStoryLastCardId(props.storyId);
			const { searchObject } = parseURL(window.location.href);

			const redirectToCheckpoint = props.oncePerUser && checkpoint && checkpoint !== cardId;
			const redirectToStoryStart = !props.oncePerUser && cardId;

			if (redirectToCheckpoint) {
				props.history.replace({ search: searchObjectToString({ ...searchObject, cardId: checkpoint }) });
			} else if (redirectToStoryStart) {
				props.history.replace({ search: searchObjectToString(_.omit(searchObject, ['cardId'])) });
			}
		}

		setStatus(true);
	});

	if (!status) return null;

	return props.children;
};

const connector = connect((state: ClientReducerState) => ({
	checkpoint: state.user.checkpoint?.cardId,
	storyId: state.story.id!,
	oncePerUser: Boolean(state.story?.storyVersions?.latest?.settings?.restrictions?.oncePerUser),
}));

export default connector(withRouter(RedirectController));
